export const environment = {
  production: false,
  hmr: false,
  apiUrl: "https://api.staging.goalngo.com",
  productionDomain: "https://api.staging.goalngo.com",
  authApi: "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword",
  // Firebase staging Web API key (matches entity-portal staging config)
  authKey: "AIzaSyDXjPvoFeMGj-lfZNnhbHtXvg3y2HbECA8",
  mediaUrl: "https://cdn.staging.goalngo.com",
};
